import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables: VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: localStorage,
  },
});

// realtime-js reuses a channel object when `supabase.channel(topic)` is called
// with a topic that is still registered — including one whose `removeChannel()`
// is still in flight. A React effect cleanup followed by a re-mount (route
// change between pages sharing a topic, StrictMode) then binds to a channel
// that is being torn down: `subscribe()` is a no-op on a non-closed channel and
// the subscription silently dies. A unique topic gives every mount its own
// channel object.
let channelSequence = 0;
export const uniqueChannelTopic = (base: string): string => {
  channelSequence += 1;
  return `${base}-${channelSequence}`;
};
